exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-message{border-top:1px solid tomato;border-bottom:1px solid tomato;margin-bottom:1.5rem;padding-top:.7rem}.c-message__title{color:tomato;text-transform:uppercase;margin:0 0 .175rem}.c-message__message{margin:0}.c-message__link{display:block;text-align:right;margin:1.05rem 0}", ""]);

// exports
